<template>
    <v-card flat>
        <v-container v-if="mentionPageReady" fill-height>
            <v-layout wrap>
                <v-flex xs12 pt-0>
                    <div class="mb-4" style="margin-left: 4px;">
                        <v-layout>
                            <v-flex>
                                <h4 class="subheading text-xs-left font-weight-regular section-title--color">{{ this.$route.name === 'mention' ? 'Keywords' : name | unescapeString }}</h4>
                                <span class="caption description--color">Created On: {{ createdAt | formatDate }}</span>
                            </v-flex>
                            <v-flex v-if="multiViewsBtnStatus" text-xs-right style="margin-top: -7px;">
                                <v-btn class="mr-0" :disabled="currentView === 1" flat icon color="bindezcolor"  @click="move('backward')">
                                    <v-icon small>
                                        fas fa-chevron-left
                                    </v-icon>
                                </v-btn>
                                <v-btn class="ml-0" :disabled="currentView === totalViews" flat icon color="bindezcolor" @click="move('forward')">
                                    <v-icon small>
                                        fas fa-chevron-right
                                    </v-icon>
                                </v-btn>
                            </v-flex>
                        </v-layout>
                    </div>
                    <div>
                        <v-chip
                                color="bindezcolor"
                                text-color="#fff"
                                label
                                disabled
                                v-for="(keyword, index) in keywordsPerView"
                                :key="index"
                        >
                            <span class="zawgyi body-2 font-weight-regular">{{keyword.name | formatKeyword}}</span>
                        </v-chip>
                        <div v-if="keywords.length === 0" class="d-flex fill-height align-center" style="height: 100px;">
                            <span style="display: inline-block;" class="section-title--color body-2">{{name}} is monitoring the whole page without any keywords.</span>
                        </div>
                    </div>
                </v-flex>
            </v-layout>
        </v-container>
        <div class="d-flex fill-height align-center" style="height: 300px" v-if="!mentionPageReady">
            <v-progress-circular
                    color="bindezcolor"
                    indeterminate
            />
        </div>
    </v-card>
</template>

<script>
	import moment from 'moment'
    import multiViews from '@/mixins/multiViews'
    import _chunk from 'lodash/chunk';
	export default {
		props: {
			name:{
				type: String,
                default: "Keywords"
            },

            createdAt: {
				type: String,
            },

			keywords: {
				type: Array,
				required: true
			},

			mentionPageReady: {
				type: Boolean,
				required: true
			},

            maximumKeywords:{
				type: Number,
                default: 10,
            }
		},
		name: "Keywords",
        mixins: [multiViews],
		filters: {
			formatDate(raw) {
				return moment(raw).format('MMMM D, YYYY')
			},
		},
		watch: {
			keywords: {
				handler(val) {
					if (val) {
						this.totalViews = Math.ceil(val.length / this.maximumKeywords);
						this.allKeywords = _chunk(val, this.maximumKeywords);
						this.keywordsView = this.allKeywords[0];
					}
				},
				immediate: true
			}
		}
	}
</script>

<style scoped>
</style>
